import * as React from "react";
import { SVGProps } from "react";

export const ChevronRightIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" fill="none" {...props}>
    <path
      stroke={props.color}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m4.676 14.324 6.56-5.804a.262.262 0 0 0 0-.39l-6.56-5.806"
    />
  </svg>
);
export default ChevronRightIcon;
